import { render, staticRenderFns } from "./performanceappraisaltable.vue?vue&type=template&id=abdf4ad2"
import script from "./performanceappraisaltable.vue?vue&type=script&lang=js"
export * from "./performanceappraisaltable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports